export class ScoreConfig {
  hasVigency: boolean;
  pageable: boolean;
  eeff: boolean;
  generalComments: boolean;
  idOperation: boolean;
  companyScore: boolean;
  analytics: boolean;
  industry: boolean;
  typeRisk: boolean;
  enabledProducts: string[];
}